/**
 * @generated SignedSource<<af5dac5d6ba856890a680e649fe6a715>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditFlight_packageDate$data = {
  readonly flight: {
    readonly " $fragmentSpreads": FragmentRefs<"FlightDetails_flight" | "PackageDateEditFlightPriceHistory_flight">;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_packageDate">;
  readonly " $fragmentType": "PackageDateEditFlight_packageDate";
};
export type PackageDateEditFlight_packageDate$key = {
  readonly " $data"?: PackageDateEditFlight_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlight_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditFlight_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightDetails_flight"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PackageDateEditFlightPriceHistory_flight"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "bae2ed324ac3f34c9cd96d1aa7fb989e";

export default node;
